import { render } from "./MainLoading.vue?vue&type=template&id=76b5fd9d"
import script from "./MainLoading.vue?vue&type=script&lang=js"
export * from "./MainLoading.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__